import { render, staticRenderFns } from "./ContasBancarias.vue?vue&type=template&id=29f2608c&scoped=true"
import script from "./ContasBancarias.vue?vue&type=script&lang=js"
export * from "./ContasBancarias.vue?vue&type=script&lang=js"
import style0 from "./ContasBancarias.vue?vue&type=style&index=0&id=29f2608c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29f2608c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VBtn,VImg,VSkeletonLoader})
